import React from 'react';
import MaterialIcon from '../MaterialIcon';

function SearchBar({ inputValue, handleSearchChange }) {
	return (
		<div className="searchBar">
			<label htmlFor="searchBar" className="searchBar__label">
				Recherche
			</label>
			<MaterialIcon className={'searchBar__icon'}>search</MaterialIcon>
			<input
				id="searchBar"
				type="text"
				placeholder="Recherche ..."
				className="searchBar__input"
				name="searchbar"
				value={inputValue}
				onChange={handleSearchChange}
			/>
		</div>
	);
}

export default SearchBar;
